import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="relative pt-12 pb-10 md:pt-32 md:pb-24 overflow-hidden bg-maternal-cream" data-id="element-71">
      {/* Subtle background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-40 pointer-events-none" data-id="element-72">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-maternal-beige blur-3xl" data-id="element-73"></div>
        <div className="absolute top-[40%] -left-[10%] w-[40%] h-[40%] rounded-full bg-maternal-amber/10 blur-3xl" data-id="element-74"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10 max-w-6xl" data-id="element-75">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-76">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="flex-1 text-center md:text-left" data-id="element-77">
            <span className="inline-block py-1 px-3 rounded-full bg-maternal-beige text-maternal-orange font-semibold text-sm mb-6 border border-maternal-amber/20" data-id="element-78">
              Para madres de adolescentes
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-79">
              Recupera a tu hijo: El método de 7 días para madres que se sienten
              ignoradas
            </h1>
            <h2 className="text-lg md:text-xl text-maternal-lightBrown mb-8 leading-relaxed font-body" data-id="element-80">
              Restaura la comunicación y detén los portazos sin necesidad de
              gritos, sermones ni castigos eternos.
            </h2>

            <div className="flex flex-col items-center md:items-start gap-4" data-id="element-81">
              <CTAButton data-id="element-82" />
              <p className="text-sm text-maternal-lightBrown/80 flex items-center mt-2" data-id="element-83">
                <span className="w-2 h-2 rounded-full bg-green-500 mr-2" data-id="element-84"></span>
                Acceso inmediato y de por vida
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex-1 w-full max-w-md md:max-w-none relative" data-id="element-85">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-86">
              <img src="https://cdn.magicpatterns.com/uploads/kioT43W2oJHDVK1iCTTmKX/heylloyd-image-1772428782748.png" alt="Conecta con tu adolescente en 7 días - Mockup del producto" className="w-full h-auto object-cover" data-id="element-87" />
              <div className="absolute inset-0 bg-gradient-to-tr from-maternal-brown/20 to-transparent pointer-events-none" data-id="element-88"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}